/**
 * Logo M5 Group — usa o PNG oficial da marca em /public/logo-m5.png
 *
 * Props:
 *  - size: altura em pixels (default 32)
 *  - onDark: aplica filtro invert pra inverter cores em fundo escuro
 *           (sidebar preta). O PNG é em fundo branco com preto+dourado,
 *           então quando invertido vira fundo preto com branco+azul — não
 *           é o que queremos. Por isso em fundo escuro usamos o mesmo PNG
 *           (com fundo branco arredondado em torno).
 *  - showText: ignorado (texto "GROUP" já está embutido no PNG)
 */
interface Props {
  size?: number;
  onDark?: boolean;
  showText?: boolean;
  className?: string;
}

export function LogoM5({ size = 40, onDark = false, className = "" }: Props) {
  // Em sidebar escura, encapsulamos com bg branco arredondado pra preservar
  // as cores originais (preto+dourado) que NÃO funcionam em fundo escuro.
  if (onDark) {
    return (
      <div
        className={`inline-flex items-center justify-center bg-white rounded-md p-1 ${className}`}
        style={{ height: size + 8, width: size + 8 }}
      >
        <img
          src="/logo-m5.png"
          alt="M5 Group"
          style={{ height: size, width: "auto", display: "block" }}
        />
      </div>
    );
  }
  return (
    <img
      src="/logo-m5.png"
      alt="M5 Group"
      style={{ height: size, width: "auto", display: "block" }}
      className={className}
    />
  );
}
